import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import NoteService from "../../../../Services/Note.service";
import NoteForm from "../../Note/NoteForm";
import useService from "../../../Hooks/useService";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import { BasicFormFormat } from "../../../UI/FormFormat/FormFormat";
const EditNote = (props) => {
    const [noteState, loadNote] = useService(NoteService.getNote);
    React.useEffect(() => {
        loadNote(props.noteId);
    }, [loadNote, props.noteId]);
    const submit = (state) => {
        if (noteState.data) {
            return NoteService.updateNoteWithText({
                noteId: props.noteId,
                noteTypes: state.noteTypes.map(({ id }) => ({ id })),
                text: state.text,
            }).then(props.onEdit);
        }
        return Promise.reject("There was a problem saving this note");
    };
    return (_jsx(ServiceResult, { state: noteState, errorMessage: "There was a problem loading additional detail about this note", children: (note) => (_jsx(BasicFormFormat, { handleSubmit: submit, defaultValue: { text: note.text, noteTypes: note.noteTypes }, onCancel: props.onCancel, children: (formVals) => _jsx(NoteForm, Object.assign({}, formVals)) })) }));
};
export default EditNote;
